// extracted by mini-css-extract-plugin
export default {"body":"Status_body__4r7g0","decline":"Status_decline__sp2VO","review":"Status_review__Ttrgd","aprove":"Status_aprove__PPCAz"};